import { lazy, Suspense } from "react";
import { useSelector } from "react-redux";

const AddPrimaryGuestDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/AddPrimaryGuestDrawer"));
const AddonsDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/AddonsDrawer"));
const TakePaymentDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/TakePaymentDrawer"));
const ApplyDiscountDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/ApplyDiscountDrawer"));
const ViewFolioDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/ViewFolioDrawer"));
const ViewGrcDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/ViewGrcDrawer"));
const RoomDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/RoomDrawer"));
const ViewInvoiceDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/ViewInvoiceDrawer"));
const ViewPaymentDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/ViewPaymentDrawer"));
const NewIdDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/NewIdDrawer"));
const IdDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/IdDrawer"));
const RefundDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/RefundDrawer"));

const ExtraOptionDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/ExtraOptionDrawer"));
const AttachToPartyDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/AttachToPartyDrawer"));
const CheckInDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/CheckInDrawer"));
const ConfirmationModalNoShow = lazy(() => import("../../components/bookingDetailsV2/Modal/ConfirmationModalNoShow"));
const DeleteBookingModal = lazy(() => import("../../components/bookingDetailsV2/Modal/DeleteBookingModal"));
const DeletePartyModal = lazy(() => import("../../components/bookingDetailsV2/Modal/DeletePartyModal"));
const CancelBookingModal = lazy(() => import("../../components/bookingDetailsV2/Modal/CancelBookingModal"));
const EditPaymentDrawer = lazy(() => import("../../components/common/components/UpdatePaymentDrawer/EditPaymentDrawer"));
const MainBookingDetailsDrawer = lazy(() => import("../../components/bookingDetailsV2/DrawerPages/Index"));
const UndoCompletedBookingModal = lazy(() => import("../../components/bookingDetailsV2/Modal/UndoCompletedBookingModal"));
const UndoNoShowBookingModal = lazy(() => import("../../components/bookingDetailsV2/Modal/UndoNoShowCancelBookingModal"));

const useAllBookingDrawerImports = () => {
  const {
    showMainBookingDetailsDrawer,
    displayPaymentPrintDrawer,
    displayInvoiceDrawer,
    showPrimaryGuestDrawer,
    showAddonsDrawer,
    showTakePaymentDrawer,
    showApplyDiscountDrawer,
    showFolio,
    showGrcDrawer,
    displayRoomDrawer,
    showExtraOptionDrawer,
    showRefundDrawer,
    showAttachToPartyDrawer,
    displayNoShowModal,
    displayDeleteBookingModal,
    displaydeletePartyModal,
    displayCancelBookingModal,
    displayCheckInDrawer,
    displayUndoCompletedBookingModal,
    displayUndoNoShowBookingModal,
  } = useSelector((store) => store.booking);

  const { hotelDetails } = useSelector((store) => store.login);

  return {
    showMainBookingDetailsDrawer,
    hotelDetails,
    drawers: (
      <Suspense fallback={null}>
      <>
        {showMainBookingDetailsDrawer?.visible && (
          <>
            <MainBookingDetailsDrawer />

            {displayPaymentPrintDrawer?.display && <ViewPaymentDrawer />}

            {displayInvoiceDrawer?.display && <ViewInvoiceDrawer />}

            {showPrimaryGuestDrawer?.visible && <AddPrimaryGuestDrawer />}

            {showAddonsDrawer && <AddonsDrawer />}

            {showTakePaymentDrawer && <TakePaymentDrawer />}

            {showApplyDiscountDrawer && <ApplyDiscountDrawer />}

            {showFolio && <ViewFolioDrawer />}

            {showGrcDrawer && <ViewGrcDrawer />}

            {showExtraOptionDrawer && <ExtraOptionDrawer />}

            {hotelDetails?.showRoomWisePersonWiseIdForGuests ? (
              <NewIdDrawer />
            ) : (
              <IdDrawer />
            )}

            {showRefundDrawer && <RefundDrawer />}

            {showAttachToPartyDrawer && <AttachToPartyDrawer />}

            {displayNoShowModal && <ConfirmationModalNoShow />}

            {displayDeleteBookingModal && <DeleteBookingModal />}

            {displaydeletePartyModal && <DeletePartyModal />}

            {displayCancelBookingModal && <CancelBookingModal />}

            {displayCheckInDrawer && <CheckInDrawer />}

            {displayUndoCompletedBookingModal && <UndoCompletedBookingModal />}

            {displayUndoNoShowBookingModal && <UndoNoShowBookingModal />}

            <EditPaymentDrawer
              isBookingListDrawer={true}
              drawerWidth={"800px"}
            />
          </>
        )}

        {displayRoomDrawer && <RoomDrawer />}
      </>
      </Suspense>
    ),
  };
};

export default useAllBookingDrawerImports;
